<template>
  <!-- 菜单权限管理 -->
  <div class="paddbox autobox">
    <div>

      <el-card>
        <div> <el-form inline :model="searchForm">
            <el-form-item label="Id:">
              <el-input v-model="searchForm.id" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="配置名称:">
              <el-input v-model="searchForm.configName" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="创建者:">
              <el-select v-model="searchForm.creator" size="mini">
                <el-option label="oaeu001" value="oaeu001"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="源数据广告主:">
              <el-select v-model="searchForm.creator" size="mini">
                <el-option label="oaeu001" value="oaeu001"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="平台:">
              <el-select v-model="searchForm.creator" size="mini">
                <el-option label="oaeu001" value="oaeu001"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="短剧:">
              <el-select v-model="searchForm.creator" size="mini">
                <el-option label="oaeu001" value="oaeu001"></el-option>
              </el-select>
            </el-form-item>
            <!-- 其他筛选项 -->
            <el-form-item>
              <el-button type="success" size="mini">提交</el-button>
              <el-button size="mini">重置</el-button>
            </el-form-item>
          </el-form></div>
        <div class="btn-toolbar">
          <!-- 左侧按钮组 -->
          <div class="left-buttons">
            <el-button-group class="my-btn-group">
              <!-- <el-button icon="el-icon-refresh-right" type="info"></el-button> -->
              <el-button plain size="mini" icon="el-icon-edit" class="btn-orange">新建端原生投放配置</el-button>
              <el-button plain size="mini" icon="el-icon-coin" class="btn-green">投放任务管理</el-button>
              <el-button plain size="mini" icon="el-icon-collection" class="btn-blue"
                @click="changeDXBviewFun()">投放定向包管理</el-button>
              <el-button plain size="mini" icon="el-icon-document-remove" class="btn-dark-blue"
                @click="changeTitleviewFun()">短剧标题库</el-button>
              <el-button plain size="mini" icon="el-icon-picture" class="btn-purple"
                @click="changeVideoFun()">短剧封面图管理</el-button>
              <el-button plain size="mini" icon="el-icon-picture" class="btn-red"
                @click="changeProductImageviewFun()">产品主图管理</el-button>
              <el-button plain size="mini" icon="el-icon-video-camera-solid" class="btn-dark"
                @click="changeVideoManageviewFun()">端原生剧目管理</el-button>
              <el-button plain size="mini" icon="el-icon-picture-outline" class="btn-light-blue">短剧海报管理</el-button>
              <!-- <el-button plain size="mini" icon="el-icon-suitcase-1" class="btn-sky">商品包管理</el-button> -->
            </el-button-group>
          </div>

          <!-- 右侧搜索 -->
          <div class="search-right">
            <el-input placeholder="搜索" size="mini" style="width:180px"></el-input>
            <el-button icon="el-icon-search" size="mini"></el-button>
          </div>
        </div>
        <!-- 下方表格 -->
        <div>
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="date" label="日期" width="180"> </el-table-column>
            <el-table-column prop="name" label="姓名" width="180"> </el-table-column>
            <el-table-column prop="address" label="地址"> </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :total="total"
            :pagesize="pagesize" :currentPage="currentPage"></pagination>
        </div>
      </el-card>
    </div>


    <div>
      <!-- 投放定向包管理弹窗控制 -->
      <el-dialog title="投放定向包管理" v-model="DXBview" width="80%">
        <ylyPackage></ylyPackage>
      </el-dialog>

      <!-- 短剧标题库弹窗控制 -->
      <el-dialog title="短剧标题库" v-model="Titleview" width="80%">
        <ylyTitle></ylyTitle>
      </el-dialog>

      <!-- 产品主图管理弹窗控制 -->
      <el-dialog title="产品主图管理" v-model="ProductImageview" width="80%">
        <ylyProductImage></ylyProductImage>
      </el-dialog>

      <!-- 短剧管理弹窗控制 -->
      <el-dialog title="短剧管理" v-model="VideoManageview" width="80%">
        <ylyVideoManage></ylyVideoManage>
      </el-dialog>

      <el-dialog title="上传测试" v-model="Videoiew" width="80%">
        <ylyUploadVideo></ylyUploadVideo>
      </el-dialog>


      <!-- 账户拉取视频弹窗控制 -->
      <el-dialog v-model="pullAccountVideoView">
        <div>
          <el-form label-width="80px">
            <el-form-item label="账户id：">
              <el-input type="number" v-model="accountId" placeholder="请输入账户id"></el-input>
            </el-form-item>
            <el-form-item label="素材id：">
              <div>
                <el-input placeholder="请输入素材id，每行一个素材id，敲击回车换行" :rows="20" type="textarea" v-model="desc"></el-input>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="downBtn flex">
          <div>
            <el-button @click="pullAccountVideoViewChange()">取消</el-button>
          </div>
          <div>
            <el-button @click="confirmFun()" type="primary">确定</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 推送视频弹窗控制 -->
      <el-dialog v-model="pushAccountVideoView">
        <div>
          <el-form label-width="100px">
            <el-form-item label="推送账户id：">
              <div>
                <el-input placeholder="请输入账户id，每行一个账户id，敲击回车换行" :rows="20" type="textarea" v-model="tdesc"></el-input>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="downBtn flex">
          <div>
            <el-button @click="pushAccountVideoViewChange()">取消</el-button>
          </div>
          <div>
            <el-button @click="pushConfirmFun()" type="primary">确定</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { selectClipLibraryAll } from '@/request/new/videosucai'
import { ElMessage } from 'element-plus'
import { inject, reactive, toRefs, watch } from 'vue'
import pagination from '@/components/pagination.vue' // 导入分页组件
import ylyPackage from '@/components/ylyBatch/ylyPackage.vue' // 导入定向包组件
import ylyTitle from '@/components/ylyBatch/ylyTitle.vue' // 导入标题库组件
import ylyProductImage from '@/components/ylyBatch/ylyProductImage.vue' // 导入产品主图组件
import ylyVideoManage from '@/components/ylyBatch/ylyVideoManage.vue' // 导入短剧管理
import ylyUploadVideo from '@/components/ylyBatch/ylyUploadVideo.vue' // 上传

export default {
  name: 'dys',
  components: { pagination, ylyPackage, ylyTitle, ylyProductImage, ylyVideoManage, ylyUploadVideo },
  setup() {
    const state = reactive({
      searchForm: {
        id: '',
        configName: '',
        creator: '',
      },
      //投放定向包管理开关
      DXBview: false,
      //投放定向包管理开关控制
      changeDXBviewFun: () => {
        state.DXBview = !state.DXBview
      },
      //短剧标题库开关
      Titleview: false,
      //短剧标题库开关控制
      changeTitleviewFun: () => {
        state.Titleview = !state.Titleview
      },
      //产品主图开关
      ProductImageview: false,
      //产品主图开关控制
      changeProductImageviewFun: () => {
        state.ProductImageview = !state.ProductImageview
      },
      //短剧管理开关
      VideoManageview: false,
      //短剧管理开关控制
      changeVideoManageviewFun: () => {
        state.VideoManageview = !state.VideoManageview
      },

      Videoiew: false,
      changeVideoFun: () => {
        state.Videoiew = !state.Videoiew
      },


      // 条数
      pagesize: 20,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 100,
      // 页数 发生改变
      handleCurrentChange: (e) => {
        state.currentPage = e
        selectClipLibraryAllFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        selectClipLibraryAllFun()
      },


    })

    const selectClipLibraryAllFun = () => {
      const datas = {
        currenPage: state.currentPage,
        size: state.pagesize,
        createTime: state.day,
        accountId: state.accountId2,
      }
      selectClipLibraryAll(datas).then((res) => {
        state.currentPage = res.data.currenPage
        state.total = res.data.totalSize
        state.tableData = res.data.data
      })
    }

    selectClipLibraryAllFun()
    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      selectClipLibraryAllFun,
    }
  },
}
</script>

<style lang="scss" scoped>
.search-right {
  margin-left: auto;
  display: flex;
  gap: 4px;
}

.btn-toolbar {
  display: flex;
  flex-wrap: nowrap;
  /* 整体强制一行，绝不换行 */
  align-items: center;
  gap: 12px;
  width: 100%;
}

.left-buttons {
  display: flex;
  gap: 2px;
  /* 允许左侧按钮容器内部压缩，空间不够就挤压，不换行 */
  flex-shrink: 1;
  overflow-x: auto;
  /* ✅重点：按钮太多，左侧出现横向滚动条，保证搜索框永远钉在同一行最右边 */
  padding-bottom: 4px;
}

.search-right {
  flex-shrink: 0;
  /* ✅重点：搜索区域禁止被压缩，固定在最右侧，绝不换行 */
  display: flex;
  gap: 4px;
  margin-left: 12px;
}

/* 你的按钮颜色样式保留 */
.btn-orange {
  background-color: #ff9500;
  color: white;
  border: none;
}

.btn-green {
  background-color: #00b42a;
  color: white;
  border: none;
}

.btn-blue {
  background-color: #409eff;
  color: white;
  border: none;
}

.btn-dark-blue {
  background-color: #2b5cb8;
  color: white;
  border: none;
}

.btn-purple {
  background-color: #722ed1;
  color: white;
  border: none;
}

.btn-red {
  background-color: #f53f3f;
  color: white;
  border: none;
}

.btn-dark {
  background-color: #1d2129;
  color: white;
  border: none;
}

.btn-light-blue {
  background-color: #69b1ff;
  color: white;
  border: none;
}

.btn-sky {
  background-color: #40c9ff;
  color: white;
  border: none;
}
</style>
